import { render, staticRenderFns } from "./UserGroup.vue?vue&type=template&id=395ed482&"
import script from "./UserGroup.vue?vue&type=script&lang=js&"
export * from "./UserGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('395ed482')) {
      api.createRecord('395ed482', component.options)
    } else {
      api.reload('395ed482', component.options)
    }
    module.hot.accept("./UserGroup.vue?vue&type=template&id=395ed482&", function () {
      api.rerender('395ed482', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/luckylogin/components/UserGroup.vue"
export default component.exports